import { Component, ViewChild } from '@angular/core';
import { Events, IonicPage, NavController, Platform, Refresher } from 'ionic-angular';
import { DiscoveryFeedMapPage } from "../discovery-feed-map/discovery-feed-map";
import { ShopPage } from "../shop/shop";
import { DiscoveryFeedListPage } from "../discovery-feed-list/discovery-feed-list";
import { HttpClient } from "@angular/common/http";
import { ApiErrorHandlerProvider } from "../../providers/api-error-handler/api-error-handler";
import { latLng, LocationServiceProvider } from "../../providers/location-service/location-service";
import { TeamServiceProvider } from "../../providers/team-service/team-service";
import { SearchServiceProvider } from "../../providers/search-service/search-service";
import { SearchResultsPage } from "../search-results/search-results";
import { CoffeShopPage } from '../coffe-shop/coffe-shop';
import { ShopNewPage } from '../shop-new/shop-new';

@IonicPage()
@Component({
  selector: 'page-search',
  templateUrl: 'search.html',
})
export class SearchPage {

  errors: {};
  loading: boolean;
  latLng: latLng;
  shops: any;
  currentLocation: string;
  searchTerm: string;
  searchError: string = '';
  searching: boolean = false;
  topShops: any[] = []; 
  allShops: any[] = []; 
  selectedCity: string = 'All';
  viewTab:any="list";  

  @ViewChild(Refresher) refresher: Refresher;

  constructor(
    public platform: Platform,
    public navCtrl: NavController,
    public events: Events,
    public locationService: LocationServiceProvider,
    private http: HttpClient,
    private teamProvider: TeamServiceProvider,
    private apiErrorHandler: ApiErrorHandlerProvider,
    private searchProvider: SearchServiceProvider
  ) {
    this.shops = null;
    this.loading = true;
    this.currentLocation = 'Finding Location ...';
    this.searchTerm = '';

    events.subscribe('geolocation:latLng', (latLng) => {
      this.latLng = latLng;
      this.currentLocation = 'Tap here to search on map';

      if (this.latLng) {
        this.loading = true;
        this.getShops();
      } else {
        this.loading = false;
        this.shops = [];
      }

    });

    events.subscribe('geolocation:location', (location) => {
      this.currentLocation = location;
    });

    events.subscribe('map:idle', (latLng, shops) => {
      this.latLng = latLng;
      this.shops = shops;
      this.locationService.getCurrentLocationName(this.latLng.lat, this.latLng.lng);
    });
    this.topRated()
    this.filterByCity('All')
  }

  ionViewWillEnter(){
    this.searchTerm = null;
  }

  ionViewDidLoad() {
    if (localStorage.getItem('lastBookingTeamId') && parseInt(localStorage.getItem('lastBookingTeamId')) > 0) {
      this.routePage(localStorage.getItem('lastBookingTeamId'));
      return;
    }
    if (localStorage.getItem('currentTeamId') && parseInt(localStorage.getItem('currentTeamId')) > 0) {
      this.routePage(localStorage.getItem('currentTeamId'))
      return;
    }

    if (this.teamProvider.isCustomApp() && localStorage.getItem('singleShop') === 'true') {
      // this.navCtrl.push(ShopPage, { shopId: this.teamProvider.shopId });
      this.navCtrl.push(ShopNewPage, { shopId: this.teamProvider.shopId });
    }
  }

  private routePage(id: string): void {
    const shopType: 'coffe' | 'barber' = localStorage.getItem('shopType') as 'coffe' | 'barber';
    if (shopType === 'coffe') {
      this.navCtrl.push(CoffeShopPage, { shopId: id });
      return;
    }
    if (shopType === 'barber') {
      // this.navCtrl.push(ShopPage, { shopId: id });
      this.navCtrl.push(ShopNewPage, { shopId: id });
      return;
    }
  }

  getShops() {

    return new Promise((resolve, reject) => {
      if (this.teamProvider.isCustomApp()) {
        this.teamProvider.getShopLocations().then((shops) => {
          this.shops = shops;
          // this.getShopQueueTime(this.shops);
          this.loading = false;
          return resolve(true);
        })
      } else {
        this.http.get(`/teams/${this.latLng.lat}/${this.latLng.lng}/10`)
          .subscribe((shops: Array<any>) => {
            this.shops = shops;
            // this.getShopQueueTime(this.shops);
            this.loading = false;
            return resolve(true);
          }, error => {
            this.loading = false;
            this.errors = this.apiErrorHandler.handleError(error);
            return reject();
          }, () => {
          });
      }
    });
  }

  getShopQueueTime(shops) {

    // Iterate over each shop and make an api request to get the current queue time
    shops.forEach(shop => {
      this.http.get(`/teams/${shop.id}/queue`)
        .subscribe((response: any) => {
          shop.queue = response;
        });
    });

  }

  openShopsMap() {
    this.navCtrl.push(DiscoveryFeedMapPage, {
      shops: this.shops,
      latLng: this.latLng
    });
  }

  openShopsList() {
    this.navCtrl.push(DiscoveryFeedListPage, {
      shops: this.shops
    });
  }

  openPage(event: any, shop: object) {
    this.navCtrl.push(ShopPage, {
      shop: shop
    });
  }

  search() {
    this.searching = true;
    this.searchProvider.search(this.searchTerm).then((shops: any) => {
      // shops.forEach(shop => {
      //   this.searchProvider.getShopQueueTime(shop).then(shopWithQueue => {
      //     shop.queue = shopWithQueue;
      //   })
      // });
      this.navCtrl.push(SearchResultsPage, {
        searchTerm: this.searchTerm,
        shops: shops,
        latLng: this.latLng
      }).then(() => {
        this.searching = false;
      })
    }).catch(error => {
      this.searchError = error.error.errors.shop[0];
      this.searching = false;
    });
  }

  topRated(){
    this.searching = true;
    this.searchProvider.topRated().then((shops: any) => {
      this.topShops = shops; // Store data in topShops variable
      this.searching = false;
    }).catch(error => {
      this.searchError = error.error.errors.shop[0];
      this.searching = false;
    });
  }
  openShopPage(event: any, shop: any) {
    if (shop && shop.settings && shop.settings.shop_type === 1) {
      this.navCtrl.push(CoffeShopPage, {
        shopId: shop.id
      });
      return
    }
    if (shop && shop.settings && shop.settings.shop_type === 0) {
      // ShopPage
      this.navCtrl.push(ShopNewPage, {
        shop: shop
      });
      return;
    }
  }

  pullToRefresh() {
    if (!this.latLng) {
      this.locationService.geolocate().then((latLng: latLng) => {
        this.locationService.getCurrentLocationName(latLng.lat, latLng.lng);
        this.events.publish('geolocation:latLng', latLng);
      });

      return;
    }
    this.topRated()
    this.filterByCity(this.selectedCity)
    this.getShops().then(() => {
      this.refresher.complete();
    }).catch(() => {
      this.refresher.complete();
    });
  }

  getTuid() {
    return localStorage.getItem('tuid');
  }

  getTrendingCuts() {
    let tuid = this.getTuid();
    return new Promise((resolve, reject) => {
      this.http.get('/favourite/user/' + tuid)
        .subscribe(favouriteShop => {
          resolve(favouriteShop);
        }, error => {
          this.errors = this.apiErrorHandler.handleError(error);
        }, () => {
          this.loading = false;
        })
    })
  }

  filterByCity(city: string) {
    this.searching = true;
    this.searchProvider.search(null,city).then((shops: any) => {
      this.getTrendingCuts().then((favouriteShop: any[]) => {
        const favouriteShopIds = new Set(favouriteShop.map(fav => fav.shop_id));
        const result = shops.map(shop => ({
          ...shop,
          is_favourite: favouriteShopIds.has(shop.id)
        }));
        this.allShops = result; // Store data in topShops variable
      })
      this.selectedCity = city;
      this.searching = false;
    }).catch(error => {
      this.searchError = error.error.errors.shop[0];
      this.searching = false;
    });
  }
  
}




// WEBPACK FOOTER //
// ./src/pages/search/search.ts